import type { EncryptedEnvelope, Seat } from "../src/types";

export const MAX_MESSAGE_BYTES = 32_768;
export const MAX_CREATE_ROOM_BYTES = 16 * 1024 * 1024;
export const MAX_ENVELOPE_BYTES = 20_000;
export const MAX_ROOM_IMPORT_BYTES = 8 * 1024 * 1024;
export const MAX_CUSTOM_ENTRIES = 100;
export const MAX_ANSWER_ROWS_PER_SEAT = 600;
export const MAX_NOTE_ROWS = 600;
export const ROOM_ID_PATTERN = /^[A-Za-z0-9_-]{20,64}$/;
export const CAPABILITY_PATTERN = /^[A-Za-z0-9_-]{32,64}$/;

export interface CreateRoomRequest {
  roomId: string;
  catalogueVersion: number;
  capabilityHashes: Record<Seat, string>;
  profileEnvelopes: Record<Seat, EncryptedEnvelope>;
  initialState?: {
    answers: Array<{
      seat: Seat;
      itemId: string;
      envelope: EncryptedEnvelope;
    }>;
    notes: Array<{
      itemId: string;
      envelope: EncryptedEnvelope;
    }>;
    customEntries: Array<{
      entryId: string;
      envelope: EncryptedEnvelope;
      createdBy: Seat;
      locked: boolean;
    }>;
  };
}

export interface ImportRoomRequest {
  answers: Array<{
    itemId: string;
    envelope: EncryptedEnvelope;
    version: number;
  }>;
  customEntries: Array<{
    entryId: string;
    envelope: EncryptedEnvelope;
  }>;
}

export type ClientMessage =
  | {
      type: "answer:save";
      itemId: string;
      envelope: EncryptedEnvelope;
      version: number;
    }
  | {
      type: "note:save";
      itemId: string;
      envelope: EncryptedEnvelope;
      version: number;
    }
  | {
      type: "profile:save";
      envelope: EncryptedEnvelope;
      version: number;
    }
  | {
      type: "custom:create";
      entryId: string;
      envelope: EncryptedEnvelope;
    }
  | {
      type: "custom:update";
      entryId: string;
      envelope: EncryptedEnvelope;
      version: number;
    }
  | {
      type: "custom:delete";
      entryId: string;
      version: number;
    }
  | {
      type: "presence";
      itemId: string;
    }
  | {
      type: "room:delete";
    }
  | {
      type: "room:expiry:reset";
    };

export type ServerMessage =
  | import("../src/types").RoomSnapshotWire
  | {
      type: "presence";
      seat: Seat;
      itemId: string | null;
    }
  | {
      type: "conflict";
      entity: "answer" | "note" | "profile" | "custom";
      itemId?: string;
      message: string;
    }
  | {
      type: "error";
      code: string;
      message: string;
    }
  | {
      type: "terminal";
      state: "expired" | "deleted";
    };

export function envelopeSize(envelope: EncryptedEnvelope) {
  return envelope.iv.length + envelope.ciphertext.length;
}
